module.exports = __webpack_public_path__ + "static/media/python.643247a6.svg";